export default {
    id: 'ID',
    member_id: 'Mitgliedsnummer',
    title: 'Organisationen',
    name: 'Name',
    parent_organisation_id: 'Übergeordnete Organisation',
    city: 'Stadt',
    type: 'Typ',
    last_active_at: 'Zuletzt aktiv',
    created_at: 'Erstellt am',
    active: 'Aktiv',
    isActive: 'Aktiv',
    isInactive: 'Inaktiv',
    categories: 'Kategorien',
    category: 'Kategorie'
}
